import { useEffect, useState } from "react";
import { WifiOutlined } from "@ant-design/icons";
import { io } from "socket.io-client";

const SOCKET_SERVER_URL = process.env.REACT_APP_SOCKET_SERVER_URL;

function SocketStatusButton() {
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    const socket = io(SOCKET_SERVER_URL);

    socket.on("connect", () => {
      console.log("Socket connected");
      setIsConnected(true);
    });

    socket.on("disconnect", () => {
      console.log("Socket disconnected");
      setIsConnected(false);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <button style={{ float: "right", marginRight: "10px" }}>
      <WifiOutlined style={{ color: isConnected ? "green" : "red" }} />
    </button>
  );
}

export default SocketStatusButton;
